var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _vm.exam
      ? _c("div", { staticClass: "exam-info" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("v-breadcrumbs", {
                      staticClass: "p-0",
                      attrs: { items: _vm.breadcrumbs },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: { "pc-width": !_vm.isMobile } }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "v-col",
                  { staticClass: "pe-8", attrs: { lg: "4" } },
                  [_c("v-img", { attrs: { src: _vm.exam.image.url } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  { staticClass: "mb-9", attrs: { lg: "8" } },
                  [
                    _c("h2", { staticClass: "text-h4" }, [
                      _vm._v(_vm._s(_vm.exam.name)),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "my-3",
                      domProps: { innerHTML: _vm._s(_vm.exam.description) },
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "my-3" },
                      [
                        _vm._l(
                          Array.from(Array(_vm.exam.difficultRate).keys()),
                          function (_, index) {
                            return [
                              _c(
                                "v-icon",
                                { key: index, staticClass: "star-icon me-1" },
                                [_vm._v("star_rate")]
                              ),
                            ]
                          }
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "Level (" + _vm._s(_vm.exam.difficultRate) + ")"
                          ),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("ExamButton", {
                      attrs: { exam: _vm.exam, user: _vm.user },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.exam
      ? _c("div", { class: { "pc-width": !_vm.isMobile } }, [
          _c(
            "div",
            { staticClass: "bg-white d-flex" },
            [
              _c(
                "v-col",
                { attrs: { lg: "8", cols: "12" } },
                [
                  !_vm.exam.isRecommendationTest
                    ? _c(
                        "div",
                        { staticClass: "mb-4 d-flex" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-center", attrs: { lg: "4" } },
                            [
                              _c(
                                "span",
                                { staticClass: "text-h2 font-weight-medium" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.exam.usersCount / 1000 > 1
                                          ? _vm.exam.usersCount / 1000
                                          : _vm.exam.usersCount
                                      ) +
                                      "\n              "
                                  ),
                                  _vm.exam.usersCount / 1000 > 1
                                    ? _c("span", [_vm._v("k")])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v("人\n            "),
                              _c("div", [_vm._v("受験者数")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "text-center", attrs: { lg: "4" } },
                            [
                              _c(
                                "span",
                                { staticClass: "text-h2 font-weight-medium" },
                                [_vm._v(_vm._s(_vm.exam.averageRate))]
                              ),
                              _vm._v("%\n            "),
                              _c("div", [_vm._v("平均スコア")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "text-center", attrs: { lg: "4" } },
                            [
                              _c(
                                "span",
                                { staticClass: "text-h2 font-weight-medium" },
                                [_vm._v(_vm._s(_vm.exam.passedCount))]
                              ),
                              _vm._v("人\n            "),
                              _c("div", [_vm._v("合格者数")]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.exam.body
                    ? _c("div", {
                        staticClass: "mb-5",
                        domProps: { innerHTML: _vm._s(_vm.exam.body) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.skills.length > 0
                    ? [
                        _c("h2", { staticClass: "text-h4 mb-4" }, [
                          _vm._v("テストするスキル"),
                        ]),
                        _vm._v(" "),
                        _c("v-data-table", {
                          staticClass: "mb-5",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.skills,
                            "hide-default-footer": "",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.exam.price
                    ? _c(
                        "v-card",
                        { staticClass: "purchase-card d-flex mb-5" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "7" } },
                                [
                                  _c("p", { staticClass: "text-h3" }, [
                                    _vm._v(_vm._s(_vm.exam.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.exam.description)),
                                  ]),
                                  _vm._v(" "),
                                  _c("ExamButton", {
                                    attrs: { exam: _vm.exam, user: _vm.user },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "5" } }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("span", { staticClass: "text-h4" }, [
                                      _vm._v(
                                        _vm._s(_vm.exam.price.toLocaleString())
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ms-1 mt-3" }, [
                                      _vm._v("円（税別）"),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.exam.courses.length > 0
                    ? [
                        _c("h2", { staticClass: "text-h4 mb-3" }, [
                          _vm._v("関連コース"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.exam.courses, function (course) {
                          return _c(
                            "v-card",
                            {
                              key: course.id,
                              staticClass: "p-5 mb-3",
                              attrs: { outlined: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    name: _vm.ROUTER_NAME.COURSE_DETAIL,
                                    params: { courseId: course.id },
                                  })
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      course.image
                                        ? _c("v-img", {
                                            attrs: { src: course.image.url },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "8" } },
                                    [
                                      course.skillList.length > 0
                                        ? _c(
                                            "p",
                                            { staticClass: "mb-0" },
                                            [
                                              _c(
                                                "v-chip",
                                                { staticClass: "me-3" },
                                                [
                                                  _vm._v(
                                                    _vm._s(course.skillList[0])
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.dateFormat(
                                                      course.createdAt
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-title",
                                        { staticClass: "text-h5 px-0" },
                                        [_vm._v(_vm._s(course.name))]
                                      ),
                                      _vm._v(" "),
                                      course.description
                                        ? _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                course.description
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { lg: "4", cols: "12" } },
                [
                  _vm.exam.isRecommendationTest
                    ? [
                        _c("div", [_vm._v("テスト製作者")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "v-col",
                              { attrs: { lg: "3" } },
                              [_c("v-img", { attrs: { src: _vm.RobotImg } })],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-col", { attrs: { lg: "7" } }, [
                              _c("p", [_vm._v("EdbaseAIBot")]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0 text-warning" }, [
                                _vm._v("ロボットによる自動作成"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.exam.director
                    ? [
                        _c("div", [_vm._v("講師")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "v-col",
                              { attrs: { lg: "3" } },
                              [
                                _c("v-img", {
                                  attrs: { src: _vm.exam.director.image.url },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-col", { attrs: { lg: "7" } }, [
                              _c("p", [_vm._v(_vm._s(_vm.exam.director.name))]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0 text-warning" }, [
                                _vm._v("School infomation"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }